import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';

@Component({
	selector: 'vex-add-email-dialog',
	imports: [
		ReactiveFormsModule,
		FormsModule,
		TranslocoDirective,
		MatFormFieldModule,
		MatDialogActions,
		MatButtonModule,
		MatDialogTitle,
		MatDialogContent,
		MatInputModule,
		MatError,
		MatIconModule,
		CdkDrag,
		CdkDragHandle,
	],
	templateUrl: './add-email-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './add-email-dialog.component.scss',
})
export class AddEmailDialogComponent implements OnInit {
	private fb = inject(FormBuilder);
	dialogRef = inject<MatDialogRef<AddEmailDialogComponent>>(MatDialogRef);
	data = inject(MAT_DIALOG_DATA);

	emailForm!: FormGroup;

	ngOnInit(): void {
		this.emailForm = this.fb.group({
			email: ['', [Validators.required, Validators.email]],
		});
	}

	cancel(): void {
		this.dialogRef.close();
	}

	save(): void {
		if (this.emailForm.valid) {
			this.dialogRef.close(this.emailForm.value.email);
		} else {
			this.emailForm.markAllAsTouched();
		}
	}
}
